/**
 * A place for Tooltip things
 * Currently using BS4 implementation
 * https://getbootstrap.com/docs/4.0/components/tooltips/
 */
namespace appn.tooltip {

    let _selector: string;

    export function init() {
        if (appn.isTestSuiteRequest)
            return;

        _selector = '[title]';

        dispose($(_selector));
        $(_selector).each(function() {
            $(this).tooltip({
                animation: true,
                container: 'body',
                delay: {
                    show: 250,
                    hide: 100
                },
                html: true,
                placement: $(this).attr('data-placement') || 'auto'
            });
        });

        addEvents();
    }

    function addEvents() {

        $(_selector).on('show.bs.tooltip', function() {
        });

        $(_selector).on('shown.bs.tooltip', function() {
        });

        $(_selector).on('hide.bs.tooltip', function() {
        });

        $(_selector).on('hidden.bs.tooltip', function() {
        });

        $(_selector).on('inserted.bs.tooltip', function() {
        });
    }

    export function show(element: JQuery<HTMLElement>) {
        element.tooltip('show');
    }

    export function hide(element: JQuery<HTMLElement>) {
        element.tooltip('hide');
    }

    export function toggle(element: JQuery<HTMLElement>) {
        element.tooltip('toggle');
    }

    export function dispose(element: JQuery<HTMLElement>) {
        (element as any).tooltip('dispose');
    }

    export function enable(element: JQuery<HTMLElement>) {
        (element as any).tooltip('enable');
    }

    export function disable(element: JQuery<HTMLElement>) {
        (element as any).tooltip('disable');
    }

    export function toggleEnabled(element: JQuery<HTMLElement>) {
        (element as any).tooltip('toggleEnabled');
    }

    export function update(element: JQuery<HTMLElement>) {
        (element as any).tooltip('update');
    }
}
